import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { Animation } from '@capacitor/status-bar/dist/esm/definitions';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  authService = inject(AuthService);

  async ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.hide({
        animation: Animation.None,
      });
    }

    if (!(await this.authService.isLoggedIn())) {
      await this.authService.getAccessToken();
    }
  }
}
